// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3m9jX","gfeWrapper":"CalendarEvent_gfeWrapper__3m238"};